import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FormControlLabel } from '@mui/material'
import { shouldForwardProp } from 'commons/utils/mui'
import { theme as newTheme } from 'styles/theme/hav-theme'

type CustomLabelProps = {
  size?: 'small' | 'default'
  bold?: boolean
}

export const FormControlLabelStyled = styled(FormControlLabel, {
  shouldForwardProp,
})<CustomLabelProps>`
  margin-right: 0;

  &.MuiFormControlLabel-root {
    margin-left: 0;

    span {
      padding: 0;
    }

    &.Mui-disabled {
      svg {
        path {
          fill: ${newTheme.colors.neutral.clear};
        }
      }
    }

    span.MuiCheckbox-root {
      margin-right: ${newTheme.spacing.xs};
      background-color: ${newTheme.colors.neutral[100]};
    }

    span.MuiTypography-root {
      padding-top: 2px;
      font-weight: ${newTheme.typography.weight.lg};

      ${({ size, bold }) =>
        size === 'small' &&
        css`
          font-size: ${newTheme.typography.sizes['2xs']};
          font-weight: ${bold ? newTheme.typography.weight.lg : newTheme.typography.weight.xsm};
        `}

      color: ${newTheme.colors.neutral.high};
      ${({ disabled }) => disabled && `color: ${newTheme.colors.neutral.medium}`}
    }
  }
`
